import { IHistoryProvider, HistoryProviderOptions, GiveFeedbackParams } from "./IProvider";
import { deleteChatHistoryApi, getChatHistoryApi, getChatHistoryListApi, ChatHistoryItem, Domain, ChatHistoryItemDetails, postV2FeedbackApi } from "../../api";

export class CosmosDBProvider implements IHistoryProvider {
    getProviderName = () => HistoryProviderOptions.CosmosDB;

    private continuationToken: string | undefined;
    private isItemEnd: boolean = false;

    resetContinuationToken() {
        this.continuationToken = undefined;
        this.isItemEnd = false;
    }

    async getNextItems(count: number, idToken?: string, domain?: Domain): Promise<ChatHistoryItem[]> {
        if (this.isItemEnd) {
            return [];
        }

        try {
            const response = await getChatHistoryListApi(count, this.continuationToken, idToken || "", domain);
            this.continuationToken = response.continuationToken ?? undefined;
            if (!this.continuationToken) {
                this.isItemEnd = true;
            }
            return response.items;
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    async getItem(id: string, idToken?: string): Promise<ChatHistoryItemDetails | null> {
        const response = await getChatHistoryApi(id, idToken || "");
        return response || null;
    }

    async deleteItem(id: string, idToken?: string): Promise<void> {
        await deleteChatHistoryApi(id, idToken || "");
        return;
    }

    async giveFeedback({ conversationId, positive, turnIndex, comment, idToken, reason }: GiveFeedbackParams): Promise<void> {
        await postV2FeedbackApi(conversationId, positive, turnIndex, comment, idToken || "", reason);
    }
}
